/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PdfTemplate } from '../models';
/**
 * PdfTemplatesApi - axios parameter creator
 * @export
 */
export const PdfTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * get all pdf templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfTemplatesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pdfTemplates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get specific pdf template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfTemplatesIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfTemplatesIdGet', 'id', id)
            const localVarPath = `/pdfTemplates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update specific pdf template
         * @param {number} id 
         * @param {PdfTemplate} [pdfTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfTemplatesIdPut: async (id: number, pdfTemplate?: PdfTemplate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfTemplatesIdPut', 'id', id)
            const localVarPath = `/pdfTemplates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pdfTemplate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PdfTemplatesApi - functional programming interface
 * @export
 */
export const PdfTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PdfTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * get all pdf templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfTemplatesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PdfTemplate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfTemplatesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get specific pdf template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfTemplatesIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfTemplatesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update specific pdf template
         * @param {number} id 
         * @param {PdfTemplate} [pdfTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfTemplatesIdPut(id: number, pdfTemplate?: PdfTemplate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfTemplatesIdPut(id, pdfTemplate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PdfTemplatesApi - factory interface
 * @export
 */
export const PdfTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PdfTemplatesApiFp(configuration)
    return {
        /**
         * get all pdf templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfTemplatesGet(options?: any): AxiosPromise<Array<PdfTemplate>> {
            return localVarFp.pdfTemplatesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * get specific pdf template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfTemplatesIdGet(id: number, options?: any): AxiosPromise<PdfTemplate> {
            return localVarFp.pdfTemplatesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * update specific pdf template
         * @param {number} id 
         * @param {PdfTemplate} [pdfTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfTemplatesIdPut(id: number, pdfTemplate?: PdfTemplate, options?: any): AxiosPromise<void> {
            return localVarFp.pdfTemplatesIdPut(id, pdfTemplate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PdfTemplatesApi - object-oriented interface
 * @export
 * @class PdfTemplatesApi
 * @extends {BaseAPI}
 */
export class PdfTemplatesApi extends BaseAPI {
    /**
     * get all pdf templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfTemplatesApi
     */
    public pdfTemplatesGet(options?: AxiosRequestConfig) {
        return PdfTemplatesApiFp(this.configuration).pdfTemplatesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get specific pdf template
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfTemplatesApi
     */
    public pdfTemplatesIdGet(id: number, options?: AxiosRequestConfig) {
        return PdfTemplatesApiFp(this.configuration).pdfTemplatesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update specific pdf template
     * @param {number} id 
     * @param {PdfTemplate} [pdfTemplate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfTemplatesApi
     */
    public pdfTemplatesIdPut(id: number, pdfTemplate?: PdfTemplate, options?: AxiosRequestConfig) {
        return PdfTemplatesApiFp(this.configuration).pdfTemplatesIdPut(id, pdfTemplate, options).then((request) => request(this.axios, this.basePath));
    }
}
